/* eslint-disable import/prefer-default-export */
export const eventForm = {
  bank_name: {
    type: 'input',
    label: 'Bank Name',
    value: '',
    config: {
      placeholder: 'Enter bank name',
    },
    errorMsg: 'Missing',
    valid: true,
    touched: false,
  },
  transaction_id: {
    type: 'input',
    label: 'Transaction number',
    value: '',
    config: {
      placeholder: 'Enter transaction number',
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  date: {
    type: 'input',
    label: 'Payment date',
    value: '',
    config: {
      placeholder: 'Enter date of payment',
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
};



// WEBPACK FOOTER //
// ./src/main/components/formStates.js